<div class="container">
  <div class="container__section">
    <div class="ducklings"></div>
  </div>
  <div class="container__section">
    <div class="duck"></div>
  </div>
</div>
